import React from "react";
import { getStep } from "../../../registry/workflowRegistry";

interface RenderComponentOptions {
  type?: string;
  key?: string | number;
  props?: any;
  elementName?: string;
  others?: Record<string, any>;
}

export const RenderComponent = ({
  type,
  key,
  props = {},
  elementName,
  others = {},
}: RenderComponentOptions) => {
  const Component = type ? getStep(type) : null;
  if (!Component) return null;

  return React.createElement(Component, {
    key,
    elementName,
    ...props,
    others,
  });
};